<template>
    <div class="artist-card-rev">
        <div :class="{ 'w-100': width < 1000 }">
            <img v-if="media.length" class="venue-img" :src="previewSrc(media[0])" />
            <img v-else class="venue-img" :src="getIcon() + 'default-logo.png'" />
        </div>
        <div class="venue-main-info">
            <div class="venue-top-info">
                <div class="venue-location">
                    <img
                        :src="getIcon() + 'icons/social/Verticalcontainer.svg'"
                        alt="/"
                        class="addr-img"
                    />
                    <span class="venue-address">{{ venueInfo.address }}</span>
                </div>
                <div v-if="venueInfo.vibe" class="tags">
                    <p
                        v-for="(vibe, index) in venueInfo.vibe.split(',').slice(0, 3)"
                        :key="index"
                    >
                        {{ vibe }}
                    </p>
                </div>
                <div v-if="venueInfo.website" class="venue-socila">
                    <img :src="getIcon() + 'website-icon.png'" alt="/" />
                    <a :href="venueInfo.website" class="venue-address">Website</a>
                </div>
                <div
                    class="venue-description"
                    :class="{
                        'show-description': readMore && width < 1300,
                        'show-description-pc': readMore && width > 1300
                    }"
                >
                    <div class="venue-descr-text">
                        {{ venueInfo.description }}
                    </div>
                </div>
                <p
                    v-if="
                        venueInfo.description
                            ? venueInfo.description.length > 1000 && width > 1300
                            : false
                    "
                    class="read-more"
                    @click="handleReadMore"
                >
                    {{ !readMore ? 'Read More' : 'Show less' }}
                </p>
                <p
                    v-if="
                        venueInfo.description
                            ? venueInfo.description.length > 240 && width > 1300
                            : false
                    "
                    class="read-more"
                    @click="handleReadMore"
                >
                    {{ !readMore ? 'Read More' : 'Show less' }}
                </p>
            </div>
            <!--@TODO: after discuss with Dastan, I hid buttons, because we don't have functionality-->
            <div class="follow-btn d-none">
                <button class="call-to-action"><span class="action-text">Follow</span></button>
            </div>
        </div>
    </div>
</template>

<script>
    import checkScreen from '@/mixins/check-screen'

    export default {
        name: 'VenueInfo',
        mixins: [checkScreen],
        props: {
            venueInfo: {
                type: Object,
                default: () => ({})
            },
            media: {
                type: Array,
                required: true
            }
        },
        data: () => ({
            readMore: false
        }),
        methods: {
            getIcon() {
                return '/images/'
            },
            handleReadMore() {
                this.readMore = !this.readMore
                if (this.venueInfo.slug && this.readMore)
                    window.open(`/venues/${this.venueInfo.slug}`, '_blank')
            }
        },
        computed: {
            previewSrc: () => (fileObj) => {
                if (fileObj instanceof File) {
                    return URL.createObjectURL(fileObj)
                } else if (typeof fileObj === 'string') {
                    return fileObj
                } else {
                    return fileObj.src
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../sass/_variables.scss';
    .read-more {
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        cursor: pointer;
    }
    .artist-card-rev {
        max-height: 425px;
        border-radius: 15px;
        background: #262626;
        display: flex;
        align-items: flex-start;
        width: 60%;
    }
    .venue-img {
        border-radius: 15px 0 0 15px;
        min-height: 425px;
        max-width: 300px;
        object-fit: cover;
    }
    .venue-main-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        padding: 20px;
    }
    .venue-top-info {
        display: flex;
        padding-bottom: 0;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
    }
    .show-description::-webkit-scrollbar {
        width: 0;
    }
    .show-description {
        max-height: max-content !important;
        overflow-y: scroll !important;
    }
    .show-description-pc {
        max-height: 200px !important;
    }
    .venue-location {
        display: flex;
        align-items: center;
        gap: 8px;
        align-self: stretch;
    }
    .addr-img {
        width: 20px;
        height: 20px;
    }
    .tags {
        display: flex;
        padding: 2px 0 4px 0;
        align-items: flex-start;
        gap: 6px;
        align-self: stretch;
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss07' on, 'ss10' on, 'ss05' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .tags p {
        border-radius: 100px;
        border: 1px solid #acacac;
        margin: 0;
        padding: 3px 10px 4px 10px;
        max-width: max-content;
        overflow: hidden;
        text-decoration: none;
        text-overflow: ellipsis;
    }
    .venue-socila {
        display: flex;
        align-items: center;
        gap: 16px;
        align-self: stretch;
    }
    .venue-description {
        display: flex;
        padding-bottom: 0;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        align-self: stretch;
        white-space: initial;
        overflow: hidden;
    }
    .venue-descr-text {
        max-width: 600px;
        white-space: pre-line;
        text-overflow: ellipsis;
        overflow: hidden;
        align-self: stretch;
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss07' on, 'ss10' on, 'ss05' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        max-height: 190px;
    }
    .follow-btn {
        display: flex;
        align-items: flex-start;
        gap: 12px;
    }
    .call-to-action {
        display: flex;
        padding: 7px 30px 9px 30px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 100px;
        background: #ba87ff;
        border: none;
    }
    .action-text {
        color: #000;
        font-feature-settings: 'dlig' on, 'ss07' on, 'ss10' on, 'ss05' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .venue-address {
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss07' on, 'ss10' on, 'ss05' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    @media (max-width: 1300px) {
        .venue-description {
            max-height: 42px;
        }
    }
    @media (max-width: 1000px) {
        .artist-card-rev {
            width: 100%;
            flex-direction: column;
            max-height: min-content;
            max-width: 600px;
        }
        .follow-btn {
            width: 100%;
        }
        .call-to-action {
            width: 100%;
        }
        .venue-img {
            min-width: 100%;
            border-radius: 15px 15px 0 0;
            min-height: 0;
            height: 200px;
        }
    }
</style>
